module.exports = __webpack_public_path__ + "media/newstyle/images/icon-ebook-orange-51b7a5c69027b062d22289f5fd28df19.svg";